module.exports = __webpack_public_path__ + "static/media/capstone_permissions.3fda1f0d.yaml";